import { useMutation, useQueryClient } from '@tanstack/react-query'
import { type ApiResponseError, fetchApiWithToken } from '~/api/utils'
import type { ApplicationInfosResponse } from '../types'

type LinkApplicantMatchPayload = {
  applicant: string
}

type LinkApplicantMatchVariables = {
  applicationId: number
  applicantId: number
}

export const useLinkApplicantMatch = () => {
  const queryClient = useQueryClient()

  return useMutation<
    ApplicationInfosResponse,
    ApiResponseError,
    LinkApplicantMatchVariables
  >({
    mutationFn: async ({ applicationId, applicantId }) => {
      const payload: LinkApplicantMatchPayload = {
        applicant: `/v1/applicants/${applicantId}`
      }

      return await fetchApiWithToken<ApplicationInfosResponse>({
        method: 'PATCH',
        url: `/v1/applications/${applicationId}`,
        data: payload
      })
    },
    onSuccess: (data, variables) => {
      queryClient.setQueryData(['applications', variables.applicationId], data)

      queryClient.invalidateQueries({
        queryKey: ['applications']
      })
    }
  })
}
